import rill from "rill";
import set from "@rill/set";
import controller from "./coaching-dashboard-controller.js";

const CoachingDashboard = (app) => {
  app.at(
    "/coaching-dashboard/*",
    rill()
      .use(set("heading", ["Coaching", "Dashboard"]))
      .setup((app) => {
        app.get("/", controller);
      })
  );
};

export default CoachingDashboard;
